import type { GuestSiteComponentProps } from '@apps/websiteCustomJsonComponents/types';
import React from 'react';
import { Form } from './Form';
import { FormLinkButton } from './FormLinkButton';
import { Flex, TextV2 } from '@withjoy/joykit';

export type FormDisplayData = {
  formId: string | null;
  type: 'embedded' | 'link';
  linkCTA?: string;
  linkHeader?: string;
};

export const FormDisplayGuest = (props: GuestSiteComponentProps) => {
  const eventId = props.data.eventId;
  const data = props.data.content as FormDisplayData;
  const { formId } = data;

  if (!formId) {
    return null;
  }

  switch (data.type) {
    case 'embedded':
      return <Form formId={formId} />;
    case 'link':
      return (
        <Flex
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          gap="1rem"
          margin="auto"
          width="100%"
        >
          {data.linkHeader && <TextV2 typographyVariant="hed3">{data.linkHeader}</TextV2>}
          <FormLinkButton
            formId={formId}
            eventId={eventId}
            ctaText={data.linkCTA}
          />
        </Flex>
      );
    default:
      return null;
  }
};
